module.exports = __webpack_public_path__ + "static/logoklondike2-6b74f9182a991dbca246287d3109e247.png";